<template>
  <transition name="c-pagetop">
    <div id="c-pagetop" v-show="isShow" :class="{'c-pagetop--bottom': isBottom}" class="c-pagetop" @click="gotoTop">
      <div class="c-pagetop__arrow"></div>
    </div>
  </transition>
</template>

<script>
  import ResizeObserver from 'resize-observer-polyfill';
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import {gsap, Cubic, ScrollToPlugin} from 'gsap/all';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    data() {
      return {
        assets_path: assets_path,
        isShow: false,
        isBottom: false,
        windowHeight: window.innerHeight,
        bottomY: 0,
        footterHeight: 0,
        btnPagetop: null
      }
    },
    store,
    mounted() {
      // オブザーバインスタンスを作成
      this.observer = new ResizeObserver(this.onResizeObserver);
      this.observer.observe(document.getElementById('c-ilady'));
      this.btnPagetop = document.getElementById('c-pagetop');

      this.$nextTick(this.start);
    },
    methods: {
      start() {
        this.onResizeObserver();
        window.addEventListener('scroll', this.scroll);
      },
      onResizeObserver(entries) {
        this.footterHeight = document.getElementById('c-footer').clientHeight + ((16 / 750) * window.innerWidth);
        this.bottomY =  this.$_getOffsetTop(document.getElementById('c-footer')).top - window.innerHeight;
        this.windowHeight = (window.innerHeight * 0.5);
        this.scroll();
      },
      scroll() {
        const scrollY = this.$_currentScrollY();
        if (this.windowHeight > scrollY) {
          this.isShow = false;
        } else {
          this.isShow = true;
        }

        if (this.isShow) {
          if (this.bottomY < scrollY) {
            this.btnPagetop.style.bottom = `${this.footterHeight}px`;
            this.isBottom = true;
          } else {
            this.btnPagetop.style.bottom = '';
            this.isBottom = false;
          }
        }
      },
      gotoTop() {
        gsap.to(window, {
          duration: 0.4,
          scrollTo: {
            y: 0,
            autoKill: false
          },
          ease: Cubic.easeOut
        });
      }
    }
  }
</script>
